export const getActurePartner = (partner: string) =>
  partner.startsWith("acture") ? partner : "";
